/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */

/**
 * [setLocalStoragePollKeys description]
 * @type {[type]}
 */
export const setLocalStoragePollKeys = (keys: string[]) => {
  return localStorage.setItem('pollKeys', keys.join(','))
}

/**
 * [putNewKeyToLocalStoragePollKeys description]
 * @type {[type]}
 */
export const putNewKeyToLocalStoragePollKeys = (keys: string[]) => {
  const existingPollKeys = getLocalStoragePollKeys()
  if (!existingPollKeys) {
    return localStorage.setItem('pollKeys', keys.join(','))
  }

  const pollKeysArray = existingPollKeys.split(',').filter(key => !!key)
  return localStorage.setItem('pollKeys', [...pollKeysArray, ...keys].join(','))
}

/**
 * [getLocalStoragePollKeys description]
 * @type {[type]}
 */
export const getLocalStoragePollKeys = () => {
  return localStorage.getItem('pollKeys')
}
